import { Component, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Loader } from '../../components/loader/loader';

@Component({
  selector: 'app-proctoring-consent',
  standalone: true,
  imports: [CommonModule, FormsModule, Loader],
  templateUrl: './proctoring-consent.component.html',
  styleUrl: './proctoring-consent.component.css'
})
export class ProctoringConsentComponent {
  @Output() consentResult = new EventEmitter<boolean>();
  
  hasAgreed = false;
  termsAccepted = false;
  isLoading = false;
  errorMessage: string | null = null;
  organizationName: string = '';
  logoUrl: string | null = null;

  constructor() {}

  ngOnInit() {
    this.organizationName = sessionStorage.getItem('organization_name') || '';
    this.logoUrl = sessionStorage.getItem('logo_url');
  }

  async accept() {
    if (!this.termsAccepted) {
      this.errorMessage = 'Please agree to the rules to continue.';
      return;
    }

    this.hasAgreed = true;
    this.consentResult.emit(true);
  }


  decline() {
     this.consentResult.emit(false);
  }
}
